define.alias("shared/components/shared/post/secondary/caption-writer/body", "preview-grid/components/shared/post/secondary/caption-writer/body");